import {
  ButtonTooltip,
  type IButtonTooltipProps,
} from 'shared/ui/Tooltip/variants/ButtonTooltip/ButtonTooltip'
import { useCopyToClipboard } from 'shared/hooks/useCopyToClipboard'

type ICopyButtonTooltip = {
  title: string
  copiData: string
  textButton: string
  width?: IButtonTooltipProps['width']
}

export const CopyButtonTooltip = ({ title, copiData, textButton, width }: ICopyButtonTooltip) => {
  const { onCopy, copied, clearCopied } = useCopyToClipboard(copiData)

  const onClose = () => {
    setTimeout(() => clearCopied(), 100)
  }

  return (
    <ButtonTooltip
      onClose={onClose}
      onClickButton={onCopy}
      textButton={copied ? 'Copied' : textButton}
      iconButton={'copy'}
      title={title}
      width={width}
    />
  )
}
